const types = {
    LOAD_DATA: 'LOAD_DATA',
    GET_DATA: 'GET_DATA',
    STORE_DATA: 'STORE_DATA',
    SAVE_DATA: 'SAVE_DATA',
    CHANGE_STATUS_FORM: 'CHANGE_STATUS_FORM',
    GET_DATA_BY_ID: 'GET_DATA_BY_ID',
    GET_DATA_BY_NUMERO_CASO: 'GET_DATA_BY_NUMERO_CASO',
    STORE_FORM_DATA: 'STORE_FORM_DATA',
    DELETE_DATA: 'DELETE_DATA',
    CLEAR_MESSAGES: 'CLEAR_MESSAGES',
    CLEAR_FORM_DATA: 'CLEAR_FORM_DATA',
    CHANGE_STATUS_FORM_CATALOGO: 'CHANGE_STATUS_FORM_CATALOGO',
    GET_MATRIZ_CONTROL: 'GET_MATRIZ_CONTROL',
    GET_DATA_BY_NUMERO_EVENTO: 'GET_DATA_BY_NUMERO_EVENTO'
}

export default types;

export const loadData = () => {
    return { type: types.LOAD_DATA };
}

export const getData = (formId, pagina, idCaso) => {
    return { type: types.GET_DATA, payload: { formId, pagina, idCaso } };
}

export const storeData = (formId, response) => {
    return { type: types.STORE_DATA, payload: { formId, response } };
}

export const saveData = (values, formId) => {
    return { type: types.SAVE_DATA, payload: { values, formId } };
}

export const getDataById = (formId, id) => {
    return { type: types.GET_DATA_BY_ID, payload: { formId, id } };
}

export const getDataByNumeroCaso = (formId, numeroCaso) => {
    return { type: types.GET_DATA_BY_NUMERO_CASO, payload: { formId, numeroCaso } };
}

export const storeFormData = (formId, data) => {
    return { type: types.STORE_FORM_DATA, payload: { formId, data } };
}

export const deleteData = (id, formId, nombreBase) => {
    return { type: types.DELETE_DATA, payload: { id, formId, nombreBase } };
}

export const changeStatus = (data, formId, action) => {
    return { type: types.CHANGE_STATUS_FORM, payload: { data, formId, action } };
}

export const changeStatusCatalogo = (message, formId, action) => {
    return { type: types.CHANGE_STATUS_FORM_CATALOGO, payload: { message, formId, action } };
}

export const clearMessages = () => {
    return { type: types.CLEAR_MESSAGES };
}

export const clearFormData = () => {
    return { type: types.CLEAR_FORM_DATA };
}

export const getMatrizControlByCriteria = (params) => {
    return { type: types.GET_MATRIZ_CONTROL, payload: { ...params } };
}

export const getDataByNumeroEvento = (formId, numeroCaso) => {
    return { type: types.GET_DATA_BY_NUMERO_EVENTO, payload: { formId, numeroCaso } };
}